module.exports = __webpack_public_path__ + "js/components/Desktop/images/bigWinampIcon-87c8d7f21fe60f0c65063549a4370881.png";